import { HelpCircle, MapPin, Magnet, Compass, TrendingUp, MessageSquare } from 'lucide-react';
import { PlaybookCategory } from '@/types/playbook/playbook';

export const playbookCategories: PlaybookCategory[] = [
  {
    id: 'provide-support',
    slug: 'support',
    name: 'Provide Instant, 24/7 Support',
    icon: HelpCircle,
    description: 'Answer common questions instantly, day or night. Free up your team for the conversations that matter most and delight your customers with immediate help.',
    order: 1,
    isActive: true
  },
  {
    id: 'physical-world',
    slug: 'physical-world',
    name: 'Bridge the Physical & Digital World',
    icon: MapPin,
    description: 'Deploy voice genies in physical locations using QR codes. Transform static objects and spaces into interactive experiences that provide instant assistance, information, and engagement.',
    order: 2,
    isActive: true
  },
  {
    id: 'capture-leads',
    slug: 'lead-capture',
    name: 'Capture & Qualify Leads',
    icon: Magnet,
    description: 'Deploy these plays to engage website traffic, capture visitor information, and automatically qualify potential customers before they even talk to your team.',
    order: 3,
    isActive: true
  },
  {
    id: 'onboard-educate',
    slug: 'onboarding',
    name: 'Onboard & Educate Users',
    icon: Compass,
    description: 'Use these plays to reduce churn and increase activation. Help new customers get started, understand your product, and find value faster.',
    order: 4,
    isActive: true
  },
  {
    id: 'amplify-marketing',
    slug: 'marketing',
    name: 'Amplify Your Marketing & Sales',
    icon: TrendingUp,
    description: 'Use your genie as an active sales tool to drive conversions, create urgency, and increase revenue through personalized interactions.',
    order: 5,
    isActive: true
  },
  {
    id: 'gather-insights',
    slug: 'insights',
    name: 'Gather Customer Insights',
    icon: MessageSquare,
    description: 'Use conversations to collect rich, qualitative feedback directly from your customers to improve your product and service.',
    order: 6,
    isActive: true
  }
];